"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxonomyResponses;
(function (TaxonomyResponses) {
    var TaxonomyResponse = /** @class */ (function () {
        function TaxonomyResponse(
        /**
         * Taxonomy group
         */
        taxonomy, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomy = taxonomy;
            this.debug = debug;
        }
        return TaxonomyResponse;
    }());
    TaxonomyResponses.TaxonomyResponse = TaxonomyResponse;
    var TaxonomiesResponse = /** @class */ (function () {
        function TaxonomiesResponse(
        /**
         * Taxonomies
         */
        taxonomies, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomies = taxonomies;
            this.pagination = pagination;
            this.debug = debug;
        }
        return TaxonomiesResponse;
    }());
    TaxonomyResponses.TaxonomiesResponse = TaxonomiesResponse;
})(TaxonomyResponses = exports.TaxonomyResponses || (exports.TaxonomyResponses = {}));
//# sourceMappingURL=responses.js.map